import { defineStore } from 'pinia'

const REPLACE_DELAY = 50

export const useModalStore = defineStore('modal', {
    state: () => ({
        isOpen: false,
        modalType: null,
        modalData: {},
        modalComponent: null,
    }),
    getters: {
        currentModal: state => ({
            type: state.modalType,
            component: state.modalComponent,
            data: state.modalData,
        }),
    },
    actions: {
        showModal({ type, component, data = {} }) {
            this.isOpen = true
            this.modalType = type
            this.modalComponent = component
            this.modalData = data
        },
        hideModal() {
            this.isOpen = false
            this.modalType = null
            this.modalComponent = null
            this.modalData = {}
        },
        replaceModal({ type, component, data }) {
            this.hideModal()
            setTimeout(() => this.showModal({ type, component, data }), REPLACE_DELAY)
        },
        updateModalData(data) {
            this.modalData = { ...this.modalData, ...data }
        },
    },
})
